// @dynamic-i18n-keys
// handle by script
import React from 'react';
import { useTranslation } from 'react-i18next';
import Check from '@wix/da-ds/pkg/Icons/Check';
import Error from '@wix/da-ds/pkg/Icons/24x24/Error';
import SystemNotification from '../../SystemNotification';
import Notification from '../Notification';

export interface Props {
  id: number;
  queueName: string;
  message?: string;
  messageLocaleKey?: string | string[];
  messageLocaleOptions?: Record<string, unknown>;
  isError?: boolean;
  cardProps?: any;
}

export const GenericNotification: React.FC<React.PropsWithChildren<Props>> = ({
  id,
  queueName,
  message,
  messageLocaleKey,
  messageLocaleOptions,
  isError = false,
  cardProps = {},
}) => {
  const { t } = useTranslation();

  return (
    <Notification
      id={id}
      queueName={queueName}
      cardComponent={SystemNotification}
      cardProps={{
        iconComponent: isError ? Error : Check,
        isError,
        ...cardProps,
      }}
    >
      {message ??
        (messageLocaleOptions !== undefined
          ? (t(messageLocaleKey ?? '', messageLocaleOptions) as React.ReactNode)
          : (t(messageLocaleKey ?? '') as React.ReactNode))}
    </Notification>
  );
};
GenericNotification.displayName = 'GenericNotification';

export default GenericNotification;
